<mat-dialog-actions class="justify-content-between">
    <h3 class="m-0 d-flex align-items-center gap-2">
        {{ 'BUTTON.BTN_MEDICAL_CERTIFICATE' | translate }}
    </h3>
    <div class="d-flex justify-content-center">
        <a mat-icon-button color="primary" (click)="printCertificate()" *ngIf="isSaved" [matTooltip]="'Print'">
            <i-tabler name="printer" class="icon-25 d-flex text-primary"></i-tabler>
        </a>
        <button mat-icon-button mat-dialog-close>
            <i-tabler name="x" class="icon-25 d-flex"></i-tabler>
        </button>
    </div>
</mat-dialog-actions>
<div *ngIf="!showPreview">
    <mat-divider></mat-divider>
    <mat-dialog-content class="mat-typography">
        <div class="patient-header-left">
            <div class="patient-avatar-container">
                <img class="patient-avatar" [src]="profileImagePathSrc" alt="Patient avatar"
                    fallbackImage="assets/images/profile/user-1.jpg" />
            </div>

            <div class="patient-info-block">
                <h4 class="patient-name m-0">{{ patientinfo.firstName }} {{ patientinfo.middleName }} {{
                    patientinfo.lastName }}({{patientinfo.patientNumber}})</h4>
                <div class="patient-meta" *ngIf="patientinfo">
                    <span class="patient-age">{{patientinfo.age}}</span>
                    <span class="patient-gender-badge" [ngClass]="patientinfo.gender === 'M' ? 'male' : 'female'">
                        {{getGenderName(patientinfo.gender)}}
                    </span>
                </div>
            </div>
        </div>

        <form [formGroup]="certificateForm">
            <div class="row m-t-10">
                <div class="col-lg-4">
                    <mat-form-field appearance="outline" class="w-100">
                        <mat-label>{{ 'LABEL.FROM_DATE' | translate }}</mat-label>
                        <input matInput [matDatepicker]="pickerFrom" formControlName="fromDate" readonly>
                        <mat-datepicker-toggle matSuffix [for]="pickerFrom"></mat-datepicker-toggle>
                        <mat-datepicker #pickerFrom disabled></mat-datepicker>
                    </mat-form-field>
                </div>
                <div class="col-lg-4">
                    <mat-form-field appearance="outline" class="w-100">
                        <mat-label>{{ 'LABEL.TO_DATE' | translate }}</mat-label>
                        <input matInput [matDatepicker]="pickerTo" formControlName="toDate" readonly>
                        <mat-datepicker-toggle matSuffix [for]="pickerTo"></mat-datepicker-toggle>
                        <mat-datepicker #pickerTo disabled></mat-datepicker>
                    </mat-form-field>
                </div>
                <div class="col-lg-4">
                    <mat-form-field appearance="outline" class="w-100">
                        <mat-label>{{ 'LABEL.REST_DAYS' | translate }}</mat-label>
                        <input matInput type="number" formControlName="restOfDays" min="1">
                    </mat-form-field>
                </div>
            </div>

            <div class="row m-t-10">
                <div class="col-lg-12">
                    <mat-form-field appearance="outline" class="w-100">
                        <mat-label>{{ 'LABEL.DIAGNOSIS' | translate }}</mat-label>
                        <textarea matInput rows="3" formControlName="diagnosis"></textarea>
                    </mat-form-field>
                </div>
            </div>

        </form>

    </mat-dialog-content>
    <mat-divider></mat-divider>

</div>
<mat-dialog-actions *ngIf="!showPreview">
    <div class="row m-t-4 w-100">
        <div class="col-lg-12 d-flex justify-content-end">
            <button mat-stroked-button class="m-r-5" (click)="onCloseDialog()">{{ 'BUTTON.BTN_CLOSE' |
                translate}}</button>
            <button mat-flat-button color="primary" (click)="saveAndPrintMedicalCertificate()" *ngIf="!isSaved">
                {{ 'BUTTON.BTN_SAVE' |translate}}
            </button>
        </div>
    </div>
</mat-dialog-actions>

<div style="display:none">
    <mat-divider></mat-divider>
    <mat-dialog-content class="mat-typography">
        <div id="certificate-preview" class="p-4 border m-2">

            <div class="certificate-body lh-lg fs-5 m-b-10">
                <p>
                    This is to certify that <strong>{{ patientinfo.firstName }} {{ patientinfo.lastName }}</strong>
                    was under <strong>Dr.{{ doctorName }}</strong> treatment for
                    <span *ngIf="certificateForm.get('diagnosis')?.value"><strong>{{
                            certificateForm.get('diagnosis')?.value}}</strong></span>.
                </p>

                <p>
                    {{ pronouns.subject }} was admitted on <strong>{{ certificateForm.get('fromDate')?.value |
                        date:'dd/MM/yyyy' }}</strong>
                    and discharged on <strong>{{ certificateForm.get('toDate')?.value | date:'dd/MM/yyyy' }}</strong>.
                </p>

                <p>
                    {{ pronouns.subject }} is advised rest for <strong>{{ certificateForm.get('restOfDays')?.value
                        }}</strong>
                    days.
                </p>

                <p>
                    {{ pronouns.subject }} is fit to resume duties from <strong>{{
                        certificateForm.get('resumeDate')?.value |
                        date:'dd/MM/yyyy' }}</strong>.
                </p>

            </div>

            <div class="row m-t-15">
                <div class="col-6">
                    <strong>Date:</strong> {{ certificateForm.get('toDate')?.value | date:'dd-MM-yyyy' }}
                </div>

            </div>
        </div>
    </mat-dialog-content>

</div>